/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, OnInit} from '@angular/core';
import {UIRouter} from '@uirouter/core';

import {ReportTemplateCopyModalComponent} from './report-template-copy-modal.component';
import {AdminResourceCopyConfig} from '../common/controller/admin-resource-copy-config';
import {AdminResourceRouteContext, readAdminResourceRouteContext} from '../common/controller/admin-resource-route-context';

@Component({
  standalone: false,
  selector: 'adn-report-template-context-route-page',
  template: `
    <adn-admin-resource-context-actions
      *ngIf="context"
      [model]="context.model"
      [modelComms]="context.modelComms"
      [isNew]="context.isNew"
      [readOnly]="context.readOnly"
      [copyConfig]="copyConfig">
    </adn-admin-resource-context-actions>
  `
})
export class ReportTemplateContextRoutePageComponent implements OnInit {
  context: AdminResourceRouteContext;

  readonly copyConfig: AdminResourceCopyConfig = {
    modalComponent: ReportTemplateCopyModalComponent,
    stateUrl: 'app.rep.report-templates.report-template',
    lcase: 'reportTemplate',
    ucase: 'ReportTemplate'
  };

  constructor(private readonly uiRouter: UIRouter) {
  }

  ngOnInit(): void {
    this.context = readAdminResourceRouteContext(this.uiRouter);
  }
}
